import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ManualInvoiceReport from './components/ManualInvoiceReport';


const ManualInvoice = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <div className="title-general-section-icon-arrow-back">
          <h3>Facturador</h3>
        </div>
      </Col>
    </Row>
    <Row>
      <ManualInvoiceReport />
    </Row>
  </Container>
);

export default ManualInvoice;